/**
 * It replaces all uppercase letters in a string with a dash followed by the lowercase version of that letter
 *
 * @param {string} str - string - The string to convert.
 * @returns {string} The dash case format like: 'a-b-c'.
 */
const camelToDashCase = (str) => {
  return str.replace(/([A-Z])/g, (m) => `-${m[0].toLowerCase()}`);
};

export { camelToDashCase as c };
